import Default from "../Pages/Dashboard/Default";
import ViewGeneralSettings from "../Pages/GeneralSettings/ViewGeneralSettings";
import AddGeneralSettings from "../Pages/GeneralSettings/AddGeneralSettings";
import EditGeneralSettings from "../Pages/GeneralSettings/EditGeneralSettings";
import ViewRoles from "../Pages/RoleManagement/ViewRoles";
import AddRole from "../Pages/RoleManagement/AddRole";
import EditRole from "../Pages/RoleManagement/EditRole";
import ViewEmployees from "../Pages/EmployeeManagement/ViewEmployees";
import AddEmployee from "../Pages/EmployeeManagement/AddEmployee";
import EditEmployee from "../Pages/EmployeeManagement/EditEmployee";
import ViewBystanders from "../Pages/BystanderManagement/ViewBystanders";
import AddBystander from "../Pages/BystanderManagement/AddBystander";
import EditBystander from "../Pages/BystanderManagement/EditBystander";
import ViewPatients from "../Pages/PatientManagement/ViewPatients";
import ViewBookings from "../Pages/BookingManagement/ViewBookings";
import ViewTimingSettings from "../Pages/TimingSettings/ViewTimingSettings";
import AddTimingSettings from "../Pages/TimingSettings/AddTimingSettings";
import EditTimingSettings from "../Pages/TimingSettings/EditTimingSettings";

export const routes = [
    { path: `${process.env.PUBLIC_URL}/dashboard`, element: <Default /> },
    { path: `${process.env.PUBLIC_URL}/general_settings`, element: <ViewGeneralSettings /> },
    { path: `${process.env.PUBLIC_URL}/add_general_settings`, element: <AddGeneralSettings /> },
    { path: `${process.env.PUBLIC_URL}/edit_general_settings`, element: <EditGeneralSettings /> },

    // Role Management
    { path: `${process.env.PUBLIC_URL}/role`, element: <ViewRoles /> },
    { path: `${process.env.PUBLIC_URL}/add_role`, element: <AddRole /> },
    { path: `${process.env.PUBLIC_URL}/edit_role`, element: <EditRole /> },

    // Employee Management
    { path: `${process.env.PUBLIC_URL}/employee`, element: <ViewEmployees /> },
    { path: `${process.env.PUBLIC_URL}/add_employee`, element: <AddEmployee /> },
    { path: `${process.env.PUBLIC_URL}/edit_employee`, element: <EditEmployee /> },

    // Bystander Management
    { path: `${process.env.PUBLIC_URL}/bystander`, element: <ViewBystanders /> },
    { path: `${process.env.PUBLIC_URL}/add_bystander`, element: <AddBystander /> },
    { path: `${process.env.PUBLIC_URL}/edit_bystander`, element: <EditBystander /> },

    // Patient Management
    { path: `${process.env.PUBLIC_URL}/patient`, element: <ViewPatients /> },

    // Booking Management
    { path: `${process.env.PUBLIC_URL}/booking`, element: <ViewBookings /> },

    // Timing Settings
    { path: `${process.env.PUBLIC_URL}/timing_settings`, element: <ViewTimingSettings /> },
    { path: `${process.env.PUBLIC_URL}/add_timing_settings`, element: <AddTimingSettings /> },
    { path: `${process.env.PUBLIC_URL}/edit_timing_settings`, element: <EditTimingSettings /> },
]